import {
  AppBar,
  Box,
  Divider,
  Grid,
  IconButton,
  Slide,
  Toolbar,
  useScrollTrigger,
} from "@mui/material";
import React from "react";
import { Outlet } from "react-router-dom";
import MenuIcon from "../../styles/svg/mobile_menu.svg";

import NavigationBoards from "./components/Boards";
import "./dashboard.scss";
import Profile from "../../components/Header/Profile";
import { useDashboardPageState } from "./hooks/useDashboardPageState";
import TenantSiteName from "../../components/TenantSiteName";
import WorklogMissing from "../../components/WorklogMissing";
import RemoveRemindTime from "../../components/WorklogMissing/RemoveRemindTime";
import DrawerGlobalComp from "../../components/Drawer";
import ChatSupport from "../../components/ChatSupport";

export default function Dashboard() {
  const {
    isMobile,
    sideBarDrawer,
    isLoading,
    isError,
    boards,
    logo,
    apiUrl,
    daily_worklog_reminder,
    isWorklogRemindExpired,
    openSidebarDrawer,
    setSidebarDrawer,
  } = useDashboardPageState();

  function HideOnScroll(props) {
    const { children, window } = props;
    const trigger = useScrollTrigger({
      target: window ? window() : undefined,
    });

    return (
      <Slide appear={false} direction="down" in={!trigger}>
        {children ?? <div />}
      </Slide>
    );
  }
  return (
    <Box>
        <ChatSupport />
      <RemoveRemindTime />
      {!isWorklogRemindExpired && daily_worklog_reminder && <WorklogMissing />}
      {isMobile ? (
        <div>
          <HideOnScroll>
            <AppBar className={`appbar ${isMobile ? "mobile-appbar" : ""}`}>
              <Toolbar>
                <IconButton
                  edge="start"
                  color="inherit"
                  aria-label="menu"
                  className="app-menu-button"
                  onClick={openSidebarDrawer}
                >
                  <img src={MenuIcon} alt="menu" className="app-menu-icon" />
                </IconButton>

                {logo ? (
                  <img
                    src={`${apiUrl}/${logo}`}
                    alt="logo"
                    width={140}
                    className="appbar-logo"
                  />
                ) : (
                  <TenantSiteName />
                )}
                <div className="justify-content-end w-100">
                  <Profile />
                </div>
              </Toolbar>
            </AppBar>
          </HideOnScroll>
          {/* <Toolbar /> */}
          <Outlet />
        </div>
      ) : (
        <Box className="wrapper_dashboard">
          <Box className="wrapper_sidebar">
            <div className="logo-container">
              {logo ? (
                <img
                  src={`${apiUrl}/${logo}`}
                  className="board-logo"
                  alt="Sofmen"
                />
              ) : (
                <TenantSiteName />
              )}
            </div>
            <Divider />
            <NavigationBoards
              boards={boards}
              isLoading={isLoading}
              isError={isError}
            />
          </Box>
          <Box className="wrapper_main_container">
            <Grid container spacing={1}>
              <Grid item xs={12}>
                <div style={{ height: "47px" }}></div>
                <div className="top-bar">
                  <Profile />
                </div>
                <div className="main-container">
                  <Outlet />
                </div>
              </Grid>
            </Grid>
          </Box>
        </Box>
      )}
      <DrawerGlobalComp
        open={sideBarDrawer}
        setOpen={setSidebarDrawer}
        anchor={"left"}
        animatedWidth={260}
      >
        <Box className="wrapper_dashboard">
          <Box className="wrapper_sidebar">
            <div className="logo-container">
              {logo ? (
                <img
                  src={`${apiUrl}/${logo}`}
                  className="board-logo"
                  alt="Sofmen"
                />
              ) : (
                <TenantSiteName />
              )}
            </div>
            {/* <Profile /> */}
            <Divider />
            <NavigationBoards
              boards={boards}
              isLoading={isLoading}
              isError={isError}
            />
          </Box>
        </Box>
      </DrawerGlobalComp>
    </Box>
  );
}
